module.exports = __webpack_public_path__ + "img/role-help-donations.c0cc0ed5.png";